<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/login/components/NavBar/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-30 11:14:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-11-09 13:31:06
-->
<template>
  <div class="login_navbar">
    <div class="login_close_back" @click.stop="back">
      <img src="@/assets/login/icon_close@2x.png" alt="" class="login_close" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="less" scoped>
.login_navbar {
  height: 44px;
  padding: 10px 24px;

  .login_close_back {
    width: 24px;
    // height: 24px;
    img {
      // padding-top: 10px;
      width: 24px;
      height: 24px;
      display: block;
    }
  }
}
</style>
